import { AgencyService } from '../../common-theme/api/agency.service';
import { Component } from '@angular/core';
import { LocaleAwareBaseComponent } from '../../common-theme/seo/locale-aware-base.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent extends LocaleAwareBaseComponent {
  public date = new Date();

  constructor(
    public agencyService: AgencyService
  ) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts